import { render, staticRenderFns } from "./PaymentSwitch.vue?vue&type=template&id=a202d7da&scoped=true&"
import script from "./PaymentSwitch.vue?vue&type=script&lang=js&"
export * from "./PaymentSwitch.vue?vue&type=script&lang=js&"
import style0 from "./PaymentSwitch.vue?vue&type=style&index=0&id=a202d7da&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a202d7da",
  null
  
)

export default component.exports